<template>
    <div v-show="show" class="bg">
        <div class="b-container">
            <div class="left"></div>
            <div class="right">
                <i class="logo"></i>
                <div class="input">
                    <p>用户名</p>
                    <input v-model="userName" type="text">
                </div>
                <div class="input">
                    <p>密码</p>
                    <input v-model="passWord" type="password">
                </div>
                <div @click="bind" class="btn">绑定</div>
                <p @click="close" class="close"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import common from "@common/common";
    import { apis } from "@common/config";

    export default {
        data() {
            return {
                show: true,
                c: null,
                platform_key: '',
                userName: '',
                passWord: '',
                isSend: false
            }
        },
        methods: {
            open(res, c) {
                console.log(res)
                this.platform_key = res;
                this.c = c;
                this.show = true;
            },
            close() {
                this.show = false;
                this.c(false)
            },
            async bind() {
                if(this.isSend) return 
                this.isSend = true;
                let pwd = await common.encrypt(this.passWord)
                const obj = {
                    username: this.userName,
                    pwd: pwd,
                    platform_key: this.platform_key
                }

                common.myFetch(apis.newMediaPlatformSubmitAccount, obj)
                .then((r) => {
                    if (r) {
                        this.$toast(r)
                        this.c(true)
                        this.show = false;
                        this.isSend = false;
                        console.log(r)
                    }else{
                        this.isSend = false;
                    }
                })
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;

    .b-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -350px;
        margin-top: -200px;
        width: 700px;
        height: 400px;
        background: #FFFFFF;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
        border-radius: 4px;

        .left {
            width: 350px;
            height: 100%;
            background: url('./assets/bg.png') no-repeat;
            background-position: center center;
            background-size: 100% 100%;
        }

        .right {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 350px;
            height: 100%;

            .close {
                position: absolute;
                top: -21px;
                right: -51px;
                width: 21px;
                height: 21px;
                background: url('./assets/close.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                user-select: none;
                cursor: pointer;
            }

            .logo {
                width: 68px;
                height: 68px;
                background: url('./assets/bPlus.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin: 63px 0 20px;
            }

            .input {
                display: flex;
                flex-direction: column;
                margin-bottom: 10px;

                p {
                    font-size: 14px;
                    line-height: 19px;
                    color: #323B4B;
                    margin-bottom: 5px;
                }

                input {
                    width: 290px;
                    height: 36px;
                    background: #F8FAFC;
                    border-radius: 4px;
                    border: 1px solid #DFE3E9;
                    font-size: 14px;
                    color: #323B4B;
                    padding: 0 14px;
                    box-sizing: border-box;
                }
            }

            .btn {
                width: 290px;
                height: 36px;
                background: url('./assets/bottom.png') no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                font-size: 14px;
                line-height: 36px;
                color: #FFF;
                font-weight: bold;
                text-align: center;
                margin-top: 10px;
                user-select: none;
                cursor: pointer;
            }
        }
    }
}
</style>